import dashboardService from './dashboard.service.js';

export default dashboardService;
